module.exports = __webpack_public_path__ + "img/login_bg.683db80f.png";